/* @flow */

import React, { useRef, useEffect, useState } from "react";
import styles from "./styles.scss";
import { useHistory } from "react-router";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import { Button } from "@crossroads/ui-components";
import { useAnalytics } from "context/analytics";
import CloseIcon from "icons/cross.svg";

type Props = {
  className?: string,
  onClose?: () => void,
};

const SearchMenu = ({ className, onClose }: Props): React$Node => {
  const history = useHistory();
  const t = useTranslate();
  const inputRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const analytics = useAnalytics();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onSubmit = (e: Event) => {
    e.preventDefault();

    if (inputRef.current !== null) {
      const { value } = inputRef.current;

      if (!value || value.length <= 2) {
        return;
      }

      history.push(`/search/${value}`);
      analytics.searchTerm(value);
    }
  };

  useEffect(() => {
    const closeOnEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && onClose) {
        onClose();
      }
    };

    window.addEventListener("keydown", closeOnEscape);

    return () =>
      window.removeEventListener("keydown", closeOnEscape);
  }, []);

  return (
    <form id="searchForm" className={cn(className, styles.block)} onSubmit={onSubmit}>
      <label className="sr-only" htmlFor="searchInput">{t("SEARCH.PLACEHOLDER")}</label>
      <input
        ref={inputRef}
        className={styles.input}
        id="searchInput"
        type="text"
        placeholder={t("SEARCH.PLACEHOLDER")}
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)} />

      <Button className={styles.submitButton}>{t("SEARCH.LABEL")}</Button>
      {onClose &&
        <Button
          type="button"
          aria-label={t("SEARCH.CLOSE")}
          className={styles.close}
          variant="blank"
          onClick={onClose}
        >
          <CloseIcon aria-label={t("ICONS.CROSS")} className={styles.closeIcon} />
        </Button>
      }
    </form>
  );
};

export default SearchMenu;
